import React, { FC, useEffect } from "react";
import { useFetcher, useLoaderData } from "react-router-dom";
import { AuthenticatorSetupDataDto } from "@green0meter/api-client";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { object, string } from "yup";
import { t } from "i18next";

import MFAForm, { MFAFormValues } from "./MFAForm";

const schema = object({
  code: string().max(10).required(t("validation.required")),
}).required();

const FormContainer: FC = () => {
  const fetcher = useFetcher();
  const { t } = useTranslation();

  const qrData = useLoaderData() as AuthenticatorSetupDataDto;

  const onSubmit = (values: MFAFormValues): void => {
    fetcher.submit(
      { ...values, secret: qrData.secret },
      {
        action: "/mfa",
        method: "post",
      },
    );
  };

  const { control, handleSubmit, setError } = useForm({
    defaultValues: {
      code: "",
    },
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (fetcher.data?.isValid === false) {
      setError("code", {
        type: "string",
        message: t("mfa.codeIsNotValid"),
      });
    }
  }, [fetcher]);

  return (
    <MFAForm
      t={t}
      control={control}
      submitting={fetcher.state === "submitting"}
      qrCode={qrData.qrCode}
      onSubmit={handleSubmit(onSubmit)}
    />
  );
};

export default FormContainer;
